module.exports = __webpack_public_path__ + "img/Pisces.2074369e.svg";